import React, { FC, useState } from 'react';
import PlacesAutocomplete from 'react-places-autocomplete';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import Skeleton from 'react-loading-skeleton';
import isEmpty from '../../Utilities/isEmpty';
import { RestaurantSettingAddress } from '../../Pages/Settings/Popups/GeneralSettingsPopUp';
import { getTimeZoneByLocation } from '../../Actions/getRestaurantActions';

export type AddressChangeHandler = (address: RestaurantSettingAddress) => void;

type Props = {
  handleAddress: AddressChangeHandler,
  value?: string,
  errors?: any
};

const GooglePlacesAutocomplete: FC<Props> = ({
  handleAddress,
  value,
  errors
}) => {
  const [addressLine, setAddressLine] = useState<string | undefined>(value);
  const [loadingPlace, setLoadingPlace] = useState<boolean>(false);

  const handleChange = (address: string) => {
    setAddressLine(address);

    if (isEmpty(address)) {
      handleAddress({ address_line: '' });
    }
  };

  const handleSelect = async (address: string) => {
    setLoadingPlace(true);
    
    try {
      const results = await geocodeByAddress(address);
      let latLong = await getLatLng(results[0])
      let response = await getTimeZoneByLocation(latLong.lat, latLong.lng);
      let timezone = response;
      
      if (!results || !results[0]) {
        throw new Error('No results found for this address');
      }

      let city = '';
      let state = '';
      let street_number = '';
      let zip = '';
      let street = '';

      results[0].address_components.forEach((item) => {
        const { types, long_name, short_name } = item;
        if (types.includes('locality')) city = long_name;
        if (types.includes('administrative_area_level_1')) state = short_name;
        if (types.includes('street_number')) street_number = short_name;
        if (types.includes('route')) street = long_name;
        if (types.includes('postal_code')) zip = short_name;
      });


      handleAddress({
        city,
        state,
        zip,
        street_number,
        street,
        address_line: address,
        longitude: latLong.lng,
        latitude: latLong.lat,
        time_zone: timezone
      });

      handleChange(address);

    } catch (error) {
      console.error('Error in handleSelect:', error);
    } finally {
      setLoadingPlace(false);
    }
  };

  return (
    <PlacesAutocomplete
      value={addressLine}
      onChange={handleChange}
      onSelect={handleSelect}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div>
          {loadingPlace ? <Skeleton height={38} /> : <input
            {...getInputProps({
              name: 'addressLine',
              placeholder: 'Search Places',
              className: `form-control ${errors?.addressLine ? 'is-invalid' : ''
                }`,
            })}
          />}
          <div className='position-absolute'>
            {suggestions?.map((suggestion, index) => {
              const className = suggestion?.active
                ? 'suggestion-item--active'
                : 'suggestion-item';
              // inline style for demonstration purpose
              const style = suggestion?.active
                ? {
                  backgroundColor: '#dee2e6',
                  cursor: 'pointer',
                  padding: '7px',
                  width: '97.5%',
                }
                : {
                  backgroundColor: '#ffffff',
                  cursor: 'pointer',
                  padding: '7px',
                  width: '97.5%',
                };
              return (
                <div
                  {...getSuggestionItemProps(suggestion, {
                    className,
                    style,
                    key: index,
                    onClick: handleSelect
                  })}
                >
                  <span>{suggestion.description}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </PlacesAutocomplete>
  );
};

export default GooglePlacesAutocomplete;